import React from 'react';

const CloseModalButton = ({ onClose }) => {
	return (
		<button
			type='button'
			onClick={onClose}
			className='project-link project-link--gray backToCV'
		>
			Back to cv
		</button>
	);
};

export default CloseModalButton;
